import { useTheme } from '../../hooks/useTheme';
import SwgwScanning from './swgw-scanning/SwgwScanning';

/**
 * Ericsson SW Gateway page
 * Migrated from Settings > SWGW Scanning
 */
function EricssonSwGateway() {
  const { theme } = useTheme();

  return (
    <div className={`${theme ? 'light-theme' : 'dark-theme'}`}>
      <SwgwScanning />
    </div>
  );
}

export default EricssonSwGateway;
